//Performs a smooth page scroll to an anchor on the same page.
//Gets overriden by barba if it's not on the same page...
//Generell musste ich barba beibringen korrekt mit anchor links umzugehen... Bei neueren Versionen funktioniert das out of the box
$(document).on('click', '.anchor-link', function(e){   
    if ($(this).attr("href").indexOf("http") == -1)
        e.preventDefault();
    else
        return;

    if (e.target.hash != "" && $(e.target.hash).length) {
        if ($(window).scrollTop() > window.innerHeight) {
            $('html, body').animate({
                scrollTop: $(e.target.hash).offset().top
            }, 800);
        }
        else {
            $('html, body').animate({
                scrollTop: $(e.target.hash).offset().top + window.innerHeight / 2
            }, 800);
        }
    }
});